module.exports = __webpack_public_path__ + "static/img/3.b9440f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/3.png
// module id = 1VsL
// module chunks = 0